import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import { getDatetimeString, getDateString } from "./dateHelper";

import styles from "./DateSelectionList.scss";

function DateSelectionButton({
  date,
  id,
  name,
  onClick,
  checked,
  variant,
  dateConfig,
  ...props
}) {
  const { locales, headlineFormat, sublineFormat } = dateConfig;

  return (
    <div className={styles["date-button-wrapper"]}>
      <label
        className={cx(styles["date-button"], variant, {
          [styles["date-button--checked"]]: checked,
        })}
        htmlFor={id}
      >
        <input
          onChange={() => onClick(date)}
          className={styles.input}
          type="radio"
          name={name}
          id={id}
          checked={checked}
          {...props}
        />
        <time
          dateTime={getDatetimeString(date)}
          className={styles["date-button__content"]}
        >
          <span className={styles["date-button__headline"]}>
            {getDateString(date, locales, headlineFormat)}{" "}
          </span>
          <span className={styles["date-button__subline"]}>
            {getDateString(date, locales, sublineFormat)}
          </span>
        </time>
      </label>
    </div>
  );
}

DateSelectionButton.Variants = {
  copy: styles["date-button--copy"],
  additional: styles["date-button--additional"],
};

DateSelectionButton.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  variant: PropTypes.string,
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  dateConfig: PropTypes.shape({
    locales: PropTypes.string,
    headlineFormat: PropTypes.objectOf(PropTypes.string),
    sublineFormat: PropTypes.objectOf(PropTypes.string),
  }),
};

DateSelectionButton.defaultProps = {
  variant: DateSelectionButton.Variants.large,
  checked: false,
  dateConfig: {
    locales: "de-DE",
    headlineFormat: { weekday: "short" },
    sublineFormat: { day: "2-digit", month: "2-digit" },
  },
};

DateSelectionButton.displayName = "DateSelectionList.Button";

export default DateSelectionButton;
